import { configureStore } from '@reduxjs/toolkit'
import walletReducer from 'store/wallet/walletSlice'
import userReducer from 'store/user/userSlice'
import whitelistReducer from 'store/whitelist/whitelistSlice'
import artistReducer from 'store/artist/artistSlice'
import networkReducer from 'store/network/networkSlice'
import { persistReducer, persistStore } from 'redux-persist'
import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'

const reducer = combineReducers({
  wallet: walletReducer,
  user: userReducer,
  whitelist: whitelistReducer,
  artist: artistReducer,
  networks: networkReducer,
})

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['user', 'wallet', 'networks'],
}

const persistedReducer = persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer: persistedReducer,
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
